import _ from 'underscore';

import BaseView from '../../admin-dashboard-list-base/item/view';
import template from './template.html';
import '../../../../shared/utils/iconHelper';

export default BaseView.extend({
	destroyTimeout: null,
	destroyDelay: 1000,

	events: {
		'change input[name="handled"]': 'onCheckboxChange',
		'click .js-toggle-body': 'onToggleBody'
	},

	template: _.template(template),

	/**
	 * checkbox change handler: handled or not
	 **/
	onCheckboxChange: function(e) {
		var checked = e.currentTarget.checked;

		// clear the timeout to remove model
		if (!checked) {
			clearTimeout(this.destroyTimeout);
			return;
		}

		// set timeout to destroy model
		this.destroyTimeout = setTimeout(function() {
			this.model.destroy({
				type: 'GET'
			});
		}.bind(this), this.destroyDelay);
	},

	/**
	 * toggle visibility body content
	**/
	onToggleBody: function(e) {
		e.preventDefault();
		this.query('.js-body').classList.toggle('is-hidden');
	}
});
